module.exports = __webpack_public_path__ + "static/media/page-intro.5d06aa90.png";